import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AlbtelecomOffer} from "../models/SearchService/albtelecom-offer.model";

@Injectable({
    providedIn: "root"
})
export class AlbtelecomHttpClientService {
    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/albtelecom";
    private readonly fullPath = `${this.base}${this.endpoint}`;
    private readonly searchURL = this.fullPath + "/search";
    private readonly validateURL = this.fullPath + "/check-number-format";
    private readonly walletURL = this.fullPath + "/payment/web";
    private readonly CCURL = `${this.fullPath}/start-cc`;
    private readonly activateOfferURL = `${this.fullPath}/activate`;
    private readonly commissionURL = `${this.fullPath}/commission`;

    constructor(private http: HttpClient) {
    }

    /**
     * searchOffers for offers
     * @param mobileNumber Mobile number
     */
    searchOffers(mobileNumber: string) {
        const params = new HttpParams().set("mobileNumber", mobileNumber);

        return this.http.get<AlbtelecomOffer[]>(this.searchURL, {
            params
        });
    }

    /**
     * validate mobile number
     * @param mobileNumber Mobile number
     */
    validate(mobileNumber: string) {
        const params = new HttpParams().set("mobileNumber", mobileNumber);

        return this.http.get<string>(this.validateURL, {
            params, responseType: "text" as "json"
        });
    }

    /**
     * Deposit money on the number using EWallet
     * @param mobileNumber Mobile number
     * @param amount Amount to deposit
     */
    payWallet(mobileNumber: string, amount: number) {
        return this.http.post<PaymentResponse>(this.walletURL, {
            msisdn: mobileNumber,
            amount: amount
        });
    }

    /**
     * Deposit money on the number using Credit Card
     * @param mobileNumber Mobile number
     * @param amount Amount to deposit
     */
    payCC(mobileNumber: string, amount: number) {
        return this.http.post<any>(this.CCURL, {
            msisdn: mobileNumber,
            amount: amount
        });
    }

    /**
     * searchOffers for offers
     * @param mobileNumber Mobile number
     * @param offer Albtelecom Offer object
     */
    activateOffer(mobileNumber: string, offer: AlbtelecomOffer) {
        return this.http.post<any>(this.activateOfferURL, {
            msisdn: mobileNumber,
            offer: offer
        });
    }

    /**
     * Get Commission when paying with credit-card
     * @param amount Mobile number
     */
    getCommission(amount: number): Promise<Commission> {
        return this.http.post<Commission>(this.commissionURL, {
            Amount: amount
        }).toPromise();
    }
}

interface Commission {
    amount: {
        komision: number,
        komisionCC: number
    };
}
